printFragmentWarnings